var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fanya"},[_c('div',{attrs:{"id":"fanya-background"}}),_vm._v(" "),_c('div',{staticClass:"chaoxing-box"},[_c('iframe',{staticClass:"chaoxing-iframe",attrs:{"src":_vm.currUrl,"frameborder":"0"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4836fa2f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Fanya.vue
// module id = null
// module chunks = 